export default {
  profile: {
    path: '/profile',
    auth: true,
    title: {
      ru: 'Профиль',
      ua: 'Профіль',
    },
  },
  profileSettings: {
    path: '/profile/settings',
    auth: true,
    title: {
      ru: 'Настройки',
      ua: 'Налаштування',
    },
  },
  supportFaq: {
    path: '/profile/support-faq',
    auth: true,
    title: {
      ru: 'Служба поддержки',
      ua: 'Служба підтримки',
    },
  },
  profileVerification: {
    modal: 'profile-verification',
    auth: true,
    title: {
      ru: 'Верификация',
      ua: 'Веріфікація',
    },
  },
  profileLimits: {
    modal: 'limits',
    auth: true,
    title: {
      ru: 'Лимиты',
      ua: 'Ліміти',
    },
  },
  kycaid: {
    modal: 'kycaid',
    auth: true,
  },
}
